import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const defaultProps = {
  width: '19',
}

export const IconSearch = ({ width }) => {
  return (
    <div className="icon-search__append">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        viewBox="0 0 24.775 24.771"
      >
        <g transform="translate(-1.999 -2.12)">
          <path
            d="M16.65,2.12h-.125A10.514,10.514,0,0,0,8.179,19.064l-5.8,5.677a1.254,1.254,0,0,0,1.755,1.792l5.8-5.677a10.477,10.477,0,0,0,6.479,2.331h.125A10.54,10.54,0,0,0,16.65,2.12Zm-.213,18.56a8.033,8.033,0,1,1,8.121-7.933,8.033,8.033,0,0,1-8.121,7.933Z"
            transform="translate(0 0)"
          />
        </g>
      </svg>
    </div>
  )
}

IconSearch.propTypes = propTypes

IconSearch.defaultProps = defaultProps

export default IconSearch
